export const GET_TENANTS_LIST_QUERY_KEY = "GET_TENANTS_LIST_QUERY_KEY";
export const GET_TENANT_DETAIL_QUERY_KEY = "GET_TENANT_DETAIL_QUERY_KEY";
export const GET_TENANTS_LOGO_QUERY_KEY = "GET_TENANTS_LOGO_QUERY_KEY";
export const GET_BULK_CASE_TEMPLATE_QUERY_KEY =
  "GET_BULK_CASE_TEMPLATE_QUERY_KEY";

export type TENANT = {
  name: string;
  timeZone: string;
  uuid: string;
  active: boolean;
  noOfOts: number;
  noOfUsers: number;
  physicalAddress: string;
  city: string;
  country: string;
  state: string;
  medicalLicenseNumber: string;
  businessLicenseNumber: string;
  noOfHospitals: number;
  realm: string;
};
